<template>
  <b-container>
    <b-row class="mt-3">
      <b-col>
        <b-container fluid>
          <b-row class="my-1">
            <b-col sm="2">
              <label for="input-small">Totale Fattura</label>
            </b-col>
            <b-col sm="10">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder="Inserisci Totale Fattura"
                v-model="totaleFattura"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="2">
              <label for="input-small">Ricarico (1.3 def)</label>
            </b-col>
            <b-col sm="10">
              <b-form-input
                id="input-small"
                size="sm"
                placeholder="Inserisci Ricarico Fattura"
                v-model="ricarico"
              ></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="2">
              <label for="giorno-small">Al Giorno Del Mese</label>
            </b-col>
            <b-col sm="10">
              <b-form-input id="giorno-small" size="sm" v-model="dataMese" type="date"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="my-1">
            <b-col sm="2"></b-col>
            <b-col sm="10">
              <b-button
                variant="outline-primary"
                @click="calcolaDati"
                style="margin-left:10px"
              >CALCOLA TOTALI</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-alert
          v-model="showDismissibleAlert"
          variant="danger"
          dismissible
        >Inserire Mese e Totale Fattura</b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="caricando" class="mt-3">
        <b-spinner
          style="width: 4rem; height: 4rem;"
          label="Large Spinner"
          variant="primary"
          type="grow"
        >Loading...</b-spinner>
      </b-col>
      <b-col v-if="!caricando">
        <b-container fluid>
          <b-row>
            <b-col>
              <div>TOTALE MINUTI TRASMESSI NEL MESE: {{ totaleStreaming }}</div>
              <div>TOTALE UTENTI NEL MESE: {{ totaleUtenti }}</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div>
                <b-table striped hover :items="datiCase"></b-table>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import datiUtenti from "../clienti";

export default {
  data() {
    return {
      showDismissibleAlert: false,
      dataMese: null,
      datiCase: [],
      ricarico: 1.3,
      totaleFattura: null,
      caricando: 0
    };
  },

  computed: {
    totaleStreaming: function() {
      let tot = this.datiCase
        .map(elem => {
          return elem.totaleMinuti || 0;
        })
        .reduce((acc, val) => {
          let totali = parseFloat(acc) + parseFloat(val);
          if (totali != undefined) {
            return parseFloat(totali).toFixed(2);
          } else {
            return totali;
          }
        }, 0);

      this.datiCase.map(elem => {
        let totaleFatturaCalcolato = this.totaleFattura * this.ricarico;
        let percentuale = parseFloat(elem.totaleMinuti * 100) / parseFloat(tot);
        elem.da_fatturare =
          ((totaleFatturaCalcolato * percentuale) / 100).toFixed(0) + " €";
        return elem;
      });

      return tot;
    },
    totaleUtenti: function() {
      return this.datiCase
        .map(elem => {
          return elem.totaleUtenti || 0;
        })
        .reduce((acc, val) => acc + val, 0);
    },
    loading: () => {
      return this.caricando > 0;
    }
  },

  methods: {
    _elabora(casa, result) {
      let streamingTotale = result.project.projectData.resources
        .map(elem => {
          return (
            elem.usage.streamedPublishedMinutes +
            elem.usage.streamedSubscribedMinutes
          );
        })
        .reduce((max, cur) => {
          let tot = parseFloat(max) + parseFloat(cur);
          if (tot > 0) {
            return parseFloat(tot).toFixed(2);
          } else {
            return tot;
          }
        }, 0);

      let totaleUtenti = result.project.sessionData.sessionSummaries.resources
        .map(sess => {
          let datiStream = sess.meetings.resources
            .map(elem => {
              return elem.totalSubscribers;
            })
            .reduce((max, cur) => parseInt(max) + parseInt(cur));
          return datiStream;
        })
        .reduce((max, cur) => parseInt(max) + parseInt(cur), 0);

      this.datiCase.push({
        casaAste: casa,
        totaleMinuti: streamingTotale,
        totaleUtenti: totaleUtenti,
        da_fatturare: 0
      });
    },
    calcolaDati() {
      this.datiCase = [];
      let dataMese = new Date(this.dataMese);
      if (
        this.dataMese == null ||
        (this.totaleFattura == 0 || this.totaleFattura == null)
      ) {
        this.showDismissibleAlert = true;
        return;
      }
      this.showDismissibleAlert = false;

      Object.keys(datiUtenti).forEach(elem => {
        let casa = elem;
        this.caricando++;
        this.$apollo
          .query({
            query: require("../graphql/GetVideoStats.gql"),
            context: { casaAste: elem },
            variables: {
              id: datiUtenti[elem].key,
              start: new Date(
                dataMese.getFullYear(),
                dataMese.getMonth(),
                1,
                0,
                1,
                0
              ),
              end: new Date(
                dataMese.getFullYear(),
                dataMese.getMonth(),
                dataMese.getDate(),
                23,
                59,
                59
              )
            }
          })
          .then(dati => {
            this.caricando--;
            this._elabora(casa, dati.data);
          });
      });
    }
  }
};
</script>